import {
  Box,
  Flex,
  LinkAnchor,
  SectionContent,
  SectionDescription,
  SectionTitle,
  xlBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { Quote } from '../../../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../../../infrastructure/internationalisation'
import {
  getProduct,
  ManagementType,
  useConfig,
} from '../../../../../../state/configuration'
import { AdditionalProfilesSummary, QuoteSummary } from '../../../../../organisms/quote'
import { useProduct } from '../../../../ProductProvider'

const tKey = TKey('components.quote-summary')

interface QuoteSummarySectionProps {
  onEditDetails: () => void
  quote: Quote
}

export const QuoteSummarySection: FunctionComponent<QuoteSummarySectionProps> = ({
  onEditDetails,
  quote,
}) => {
  const { t } = useWriskTranslation()

  const { scheme } = useProduct()

  const { summary } = useConfig(getProduct(scheme.schemeCode))

  const sections = summary.map((it) => {
    return (() => {
      switch (it.type) {
        case ManagementType.ADDITIONAL_PROFILE:
          return (
            <AdditionalProfilesSummary
              key={it.id}
              config={it}
              quote={quote}
              tKey={tKey}
            />
          )
        default:
          return <QuoteSummary key={it.id} config={it} quote={quote} tKey={tKey} />
      }
    })()
  })

  const subheader = t(tKey('subheader'), { defaultValue: null })

  return (
    <Box width={1} mb={xlBumps}>
      <Flex width={1}>
        <SectionTitle mr={4}>{t(tKey('header'))}</SectionTitle>
        <LinkAnchor variant='standalone' typoSize='sm' onClick={onEditDetails}>
          {t(tKey('update-details'))}
        </LinkAnchor>
      </Flex>
      {subheader && <SectionDescription>{subheader}</SectionDescription>}
      <SectionContent>
        <Box width={1} p={2} variant='raised'>
          {sections}
        </Box>
      </SectionContent>
    </Box>
  )
}
